import { Link } from 'react-router-dom';
import JsonLd from '../../components/seo/JsonLd';
import SEOHead from '../../components/seo/SEOHead';

export default function LegalPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const jsonLdData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/legal#webpage`,
    url: `${siteUrl}/legal`,
    name: '特定商取引法に基づく表記 - AIいのちゃん',
    description: 'AIいのちゃんの特定商取引法に基づく表記をご確認ください。',
    inLanguage: 'ja',
    isPartOf: {
      '@id': `${siteUrl}/#website`
    }
  };

  const items = [
    { label: '販売事業者', value: 'プレザント株式会社' },
    { label: '運営統括責任者', value: '木村 洋介' },
    { label: '所在地', value: '東京都渋谷区富ヶ谷（※詳細はご請求時に遅滞なく開示します）' },
    { label: '連絡先', value: 'grandma@pleasant-jp.com（※電話番号はメールご請求時に遅滞なく開示します）' },
    { label: '販売価格', value: '各商品／申込ページに表示（消費税込）' },
    { label: '商品代金以外の必要料金', value: '通信費等（利用者負担）' },
    { label: '支払方法・時期', value: 'クレジットカード（Square）。申込確定時に課金' },
    { label: '引き渡し時期', value: '決済完了後、即時または各ページ記載の提供時期' },
    { label: '返品・キャンセル', value: 'デジタル提供後のキャンセル不可（瑕疵時は返金可）。詳細は返品・返金ポリシーをご確認ください。' },
  ];

  return (
    <>
      <SEOHead
        title="特定商取引法に基づく表記 - AIいのちゃん"
        description="AIいのちゃんの特定商取引法に基づく表記をご確認ください。"
        canonical={`${siteUrl}/legal`}
      />
      <JsonLd data={jsonLdData} />

      <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50 px-4 py-12">
        <div className="max-w-2xl mx-auto">
          <Link to="/" className="inline-flex items-center text-purple-500 text-sm mb-6 hover:opacity-70 transition-opacity">
            <i className="ri-arrow-left-line mr-1" />
            トップへ戻る
          </Link>

          <h1 className="text-2xl font-bold text-gray-800 mb-8">特定商取引法に基づく表記</h1>

          <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
            {items.map((item, index) => (
              <div
                key={index}
                className={`flex flex-col sm:flex-row px-6 py-4 ${index !== items.length - 1 ? 'border-b border-gray-100' : ''}`}
              >
                <span className="text-xs font-semibold text-purple-500 w-full sm:w-48 shrink-0 mb-1 sm:mb-0">
                  {item.label}
                </span>
                <span className="text-sm text-gray-700 leading-relaxed">{item.value}</span>
              </div>
            ))}
          </div>

          <p className="text-xs text-gray-400 text-center mt-8">
            お問い合わせはメールのみ：grandma@pleasant-jp.com
          </p>
        </div>
      </div>
    </>
  );
}
